import { HeadCell } from 'components/gifts-table/TableList';
import deleteIcon from 'assets/img/delete.svg';
import styles from './styles.module.scss';

export default function CancelTable(props) {
  const {
    isBody,
    align = 'center',
    estatus,
    id,
    setDataField,
    stopParentPropagation,
    setShow,
  } = props;
  const handleClick = () => {
    if (stopParentPropagation) {
      stopParentPropagation();
    }
    setDataField(id);
    setShow(true);
  };
  return (
    <>
      {isBody ? (
        <td className={`text-${align}`}>
          {estatus === 'Open' ? (
                <div
                  className={`${styles.trashCan}`}
                  onClick={handleClick}
                  onKeyPress={handleClick}
                  role="button"
                > {/*  ajuste LALO */}
                  <img src={deleteIcon} alt="Eliminar mesa" /> Eliminar
                </div>

          ) : (
            estatus
          )}
        </td>
      ) : (
        <HeadCell className="text-center" column={props} />
      )}
    </>
  );
}
